﻿import State from './State.js';
import Deck from './Deck.js';

export default class StateCut extends State {
    constructor(context) {
        super(context);  //this.context = type of 'Cribbage'
        this.name = 'cut';
    }
    setup() {

        //shuffle
        var deck = new Deck();
        deck.shuffle(this.context.cards);
        for (var i = 0; i < this.context.cards.length; i++) {
            let card = this.context.cards[i];
            card.pile = "cut"
            card.pilez = i;
            card.showfront = true;
        }

        this.context.playerTurn = "";
        this.context.sendEvent("cardMoved");

        this.createMessage();
    }
    action(command, value, player) {
        switch (command) {
            case "play": return this.cut(value, player); break;
            case "endCut": return this.endCut(player); break;
            default: this.unknownCommand(command, value, player);
        }
        this.createMessage();
    }
    getActions(player) {
        let actions = [];
        let pileCut1 = this.context.getPile("cut1");
        let pileCut2 = this.context.getPile("cut2");

        if (pileCut1.length > 0 && pileCut2.length > 0) {
            actions.push({ command: "endCut" });
        } else {
            if (player === "player1" && pileCut1.length > 0) return [];
            if (player === "player2" && pileCut2.length > 0) return [];
            if (!player) return [];
            let pileCut = this.context.getPile("cut");
            for (var i = 0; i < pileCut.length; i++) {
                let card = pileCut[i];
                actions.push({ command: "play", value: card.id,player:player });
            }
        }
        return actions;
    }
    createMessage() {

        let pileCut1 = this.context.getPile("cut1");
        let pileCut2 = this.context.getPile("cut2");

        if (pileCut1.length === 0 && this.context.currentState === "cut") {
            this.context.sendEvent("message", "Select a card for the cut");
            this.context.messagePlayer1 = "Select a card for the cut";
        }
        // //highest card gets first turn
        // if (pileCut1[0].number > pileCut2[0].number) {
        //     this.context.sendEvent("message", "Computer wins the cut and starts with the Crib");
        // }
        // else {
        //     this.context.sendEvent("message", "You win the cut and starts with the Crib");
        // }
    }
    cut(cardId, player) {
        let pileCut1 = this.context.getPile("cut1");
        let pileCut2 = this.context.getPile("cut2");
        let card = this.context.getCard(cardId);
        
        if (!card) {
            this.invalidMove("Not a valid card", card);
            return;
        }
        //can play move?
        if (player === "player1") {
            if (pileCut1.length > 0) {
                this.invalidMove("Player 1 already drew a cut card", player);
                return;
            }
        }
        if (player === "player2") {
            if (pileCut2.length > 0) {
                this.invalidMove("Player 2 has already drew a cut card", player);
                return;
            }
        }
        if (!player) {
            this.invalidMove("Not a valid player", player);
            return;
        }
        if (card.pile !== "cut") {
            this.invalidMove("Must pull a card from the 'cut' pile", player);
            return;
        }


        ////pull by index
        // if (Number(cardNumber) < 0 || Number(cardNumber) >= 52) {
        //     this.invalidMove("Selected card is not between 1-52");
        //     return;
        // }
        // let cardIndex = Number(cardNumber);
        // let card = this.context.getPile("cut")[cardIndex];

        //if no card found then just end
        if (!card) return;

        //draw card
        if (player === "player1") {
            card.showfront = false;
            this.context.addToPile(card, "cut1", player);
            this.context.playerTurn = "player2";
        }
        if (player === "player2") {
            card.showfront = false;
            this.context.addToPile(card, "cut2", player);
            this.context.playerTurn = "player1";
        }


        pileCut1 = this.context.getPile("cut1");
        pileCut2 = this.context.getPile("cut2");

        if (pileCut1.length > 0 && pileCut2.length > 0) {
            // //if tie reset game
            // if (pileCut1[0].number === pileCut2[0].number) {
            //     this.context.sendEvent("message", "Tie. Start over.");
            //     this.context.setState("preGame");
            //     return;
            // }

            this.context.messagePlayer1 = "";
            this.context.messagePlayer2 = "";

            //lowest card gets crib
            if (pileCut1[0].number < pileCut2[0].number) {
                this.context.playerTurn = "player2";
                this.context.dealer = "player1";
                this.context.dealerStart = "player1";
                this.context.sendEvent("message", "Blue wins the cut and starts with the Crib");
                this.context.messagePlayer1 = "Blue wins the cut";// and starts with the Crib";
            }
            if (pileCut1[0].number == pileCut2[0].number) {
                this.context.playerTurn = "player2";
                this.context.dealer = null;
                this.context.dealerStart = null;
                this.context.sendEvent("message", "You tie the cut");
                this.context.messagePlayer1 = "Tie";// and starts with the Crib";
            }
            if (pileCut1[0].number > pileCut2[0].number) {
                this.context.playerTurn = "player1";
                this.context.dealer = "player2";
                this.context.dealerStart = "player2";
                this.context.sendEvent("message", "Red wins the cut and starts with the Crib");
                this.context.messagePlayer2 = "Red wins the cut";// and starts with the Crib";
            }
        }
        return true;
    }
    endCut() {
        let pileCut1 = this.context.getPile("cut1");
        let pileCut2 = this.context.getPile("cut2");
        //have both players pulled a high card?
        if (pileCut1.length > 0 && pileCut2.length > 0) {
            //compare high cards

            //if tie reset game
            if (pileCut1[0].number === pileCut2[0].number) {
                // this.context.setState("preGame");
                this.setup();
                return true;
            }
            //highest card gets first turn
            if (pileCut1[0].number > pileCut2[0].number) {
                this.context.playerTurn = "player1";
                this.context.dealer = "player2";
            }
            else {
                this.context.playerTurn = "player2";
                this.context.dealer = "player1";
            }

            //call setup crib state
            this.context.setState("crib");
        }
        return true;
    }

    //note: move invalidMove and unknownCommand to context? so no events are called from state?
    invalidMove(message, player) {
        this.context.sendEvent("invalidMove", message, player);
    }
    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}